import { useState, useEffect } from 'react';
import { generateTableOfContents, addHeadingIds, wrapTables } from '../helpers/blogUtils';

/**
 * Custom hook for managing table of contents
 * @param {Object} blog - Blog object with Detail property
 * @param {string} contentSelector - CSS selector for content container
 * @returns {Object} Object containing tableOfContents array and utility functions
 */
export const useTableOfContents = (blog, contentSelector) => {
    const [tableOfContents, setTableOfContents] = useState([]);

    // Generate table of contents from blog content
    useEffect(() => {
        if (blog?.Detail) {
            const toc = generateTableOfContents(blog.Detail);
            setTableOfContents(toc);
        }
    }, [blog?.Detail]);

    // Add IDs to headings in the rendered content
    useEffect(() => {
        if (tableOfContents.length > 0) {
            addHeadingIds(tableOfContents, contentSelector);
        }
    }, [tableOfContents, contentSelector]);

    // Wrap tables in responsive containers
    useEffect(() => {
        if (blog) {
            wrapTables(contentSelector);
        }
    }, [blog, contentSelector]);

    return {
        tableOfContents,
        setTableOfContents
    };
};
